import {Card} from 'platform/components';
import {Box} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {
  DmsDataGrid,
  INVOICE_PREDEFINED_COLUMNS,
  Section,
  useCustomerUrl,
  useInvoiceActionCallback,
} from '@dms/shared';

import type {QueryFilterObject} from 'features/eag-grid';

export function Invoices() {
  const {customerId} = useCustomerUrl();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {customer: [customerId]}]),
    [customerId]
  );

  const actionCallback = useInvoiceActionCallback();

  return (
    <Section>
      <Card title={i18n.t('entity.customer.labels.invoices')}>
        <Box height={175}>
          <DmsDataGrid
            data-testid="customer-invoicing"
            gridCode="customer-invoicing"
            queryModifier={queryModifier}
            actionCallback={actionCallback}
            predefinedColumns={INVOICE_PREDEFINED_COLUMNS}
          />
        </Box>
      </Card>
    </Section>
  );
}
